import { render } from "./EmployeeOverview.vue?vue&type=template&id=a8fb8ac0&scoped=true"
import script from "./EmployeeOverview.vue?vue&type=script&lang=js"
export * from "./EmployeeOverview.vue?vue&type=script&lang=js"

import "./EmployeeOverview.vue?vue&type=style&index=0&id=a8fb8ac0&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8fb8ac0"]])

export default __exports__